import * as React from 'react';
import PropTypes from 'prop-types';
import { ChildrenWrapper } from './Accordion.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultElement = 'div';
function Accordion(props) {
  const {
    expanded,
    children: childrenProp
  } = props;
  const [summaryContent, ...children] = React.Children.toArray(childrenProp);
  const childrenRef = React.useRef(null);
  React.useLayoutEffect(() => {
    const {
      current
    } = childrenRef;
    if (!current) {
      return;
    }
    current.style.height = expanded ? `${current.scrollHeight}px` : '0px';
  }, [expanded, childrenProp]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      role: "button",
      children: summaryContent
    }), /*#__PURE__*/_jsx(ChildrenWrapper, {
      ref: childrenRef,
      children: children
    })]
  });
}
Accordion.propTypes = {
  expanded: PropTypes.bool,
  children: PropTypes.node
};
export default Accordion;